export default __webpack_public_path__ + "static/media/S-014.6e44b70e.png";